import { request } from './request'
const host = 'http://yapi.batmobi.cn/mock/382'

// 获取店铺列表
export const getShopList = params => {
    const url = '/ocean/api/v1/shop/selectShoplus'
    return request({
        method: 'get',
        url: url,
        params
    })
}

// 获取专辑列表
export const getAlbumList = params => {
    const url = '/ocean/api/v1/product/collections/list'
    return request({
        method: 'get',
        url: url,
        params
    })
}
// 获取专辑详情
export const getAlbumDetail = id => {
    const url = `/ocean/api/v1/product/collections/detail/${id}`
    return request({
        method: 'get',
        url: url
    })
}
// 获取专辑详情
export const refreshAlbum = id => {
    const url = `/ocean/api/v1/product/collections/refresh/${id}`
    return request({
        method: 'post',
        url: url
    })
}

// 新增或修改专辑
export const saveOrUpdateAlbum = data => {
    const url = '/ocean/api/v1/product/collections/saveOrUpdate'
    return request({
        method: 'post',
        url: url,
        data
    })
}
// 删除专辑
export const deleteAlbum = data => {
    const url = `/ocean/api/v1/product/collections/delete`
    return request({
        method: 'delete',
        url: url,
        data
    })
}
// 根据条件获取专辑列表
export const getGoodsListByConditions = data => {
    const url = `/ocean/api/v1/product/collections/conditions`
    return request({
        method: 'post',
        url: url,
        data
    })
}

// 发布专辑
export const publishAlbum = id => {
    const url = `/ocean/api/v1/product/collections/publish/${id}`
    return request({
        method: 'put',
        url: url
    })
}

// 获取商品列表
export const getGoodsList = data => {
    const url = `/ocean/api/v1/product/collections/spuList`
    return request({
        method: 'post',
        url: url,
        data: data
    })
}

// 获取商品专辑同步数量
export const getSyncCount = data => {
    const url = `/ocean/api/v1/product/collections/count`
    return request({
        method: 'post',
        url: url,
        data: data
    })
}
// 获取商品专辑同步数量
export const getSyncList = data => {
    const url = `/ocean/api/v1/product/collections/syncCollection`
    return request({
        method: 'post',
        url: url,
        data: data
    })
}

// 获取商品专辑店铺列表
export const getSyncShopList = data => {
    const url = `/ocean/api/v1/product/collections/syncCount`
    return request({
        method: 'post',
        url: url,
        data: data
    })
}

// 获取商品专辑店铺列表
export const syncAlbum = data => {
    const url = `/ocean/api/v1/product/collections/syncToDB`
    return request({
        method: 'post',
        url: url,
        data
    })
}

// 获取同步日志
export const getSyncLog = data => {
    const url = `/ocean/api/v1/product/collections/syncTaskList`
    return request({
        method: 'post',
        url: url,
        data
    })
}

// 获取同步日志
export const syncLog = data => {
    const url = `/ocean/api/v1/product/collections/retrySyncCollection`
    return request({
        method: 'post',
        url: url,
        data
    })
}
